/* Navegación AD360 fuera de la portada y enlaces profundos hacia pantallas internas. */
(function(){
  function init(){
    var nav=document.querySelector('.ad360-global-nav');
    if(nav){
      var opener=nav.querySelector('#ad-nav-open'),closer=nav.querySelector('#ad-nav-close'),shade=nav.querySelector('#ad-nav-shade'),panel=nav.querySelector('#ad-navigation');
      function toggle(open){nav.classList.toggle('ad-nav-is-open',open);panel.setAttribute('aria-hidden',String(!open));opener.setAttribute('aria-expanded',String(open));shade.hidden=!open;}
      opener.addEventListener('click',function(){toggle(true)});closer.addEventListener('click',function(){toggle(false)});shade.addEventListener('click',function(){toggle(false)});
      document.addEventListener('keydown',function(e){if(e.key==='Escape')toggle(false)});
    }
    var root=document.getElementById('ad-shop');
    if(root){
      var route=new URLSearchParams(location.search).get('ad360');
      if(route){
        var selectors={news:'[data-nav="news"]',delivery:'[data-nav="delivery"]',menu:'[data-nav="delivery"]',stores:'[data-nav="stores"]',jobs:'[data-nav="jobs"]',corporate:'[data-nav="corporate"]',cart:'[data-nav="cart"]',scoop:'[data-scoop-open]'};
        var button=root.querySelector(selectors[route]||'#__ad360_missing__');
        if(button){button.click();if(route==='scoop' && !document.querySelector('[data-scoop-open]')){} }
      }
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
